<template>
<div class="empty-layout">
  <slot></slot>
</div>
</template>

<script>
export default {}
</script>
